export { useUtils as useUtils };
export { _ as _ };
import utils from './utils';

const useUtils = () => ({
  ...utils
});
const _ = null;

export default { useUtils };
